import { render } from "./CardProductHorizontal.vue?vue&type=template&id=7e02318d&scoped=true"
import script from "./CardProductHorizontal.vue?vue&type=script&lang=js"
export * from "./CardProductHorizontal.vue?vue&type=script&lang=js"

import "./CardProductHorizontal.vue?vue&type=style&index=0&id=7e02318d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e02318d"]])

export default __exports__